<mat-dialog-content style="max-height: 85vh; max-width: 85vw;">
    <ngx-json-viewer [json]="data"></ngx-json-viewer>
</mat-dialog-content>